var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{attrs:{"lib":"highcharts","dataforce":""},model:{value:(_vm.salesLinearCharts),callback:function ($$v) {_vm.salesLinearCharts=$$v},expression:"salesLinearCharts"}})
}
var staticRenderFns = []

export { render, staticRenderFns }